import React, { useState, useEffect } from "react";
import Loader from "./Loader.js";
import {
  X,
  Camera,
  Fuel,
  Key,
  FileText,
  ArrowRight,
  ArrowLeft,
} from "lucide-react";
import "./Css/Repo.css";
import Header from "./Header";
import {
  server_post_data,
  car_repo_api,
} from "../ServiceConnection/serviceconnection";
import {
  handleError,
  handleSuccessSession,
  goBack,
} from "../CommonJquery/CommonJquery";
import { useLocation } from "react-router-dom";
import GreyArrow from "../assets/greyLeftAr.png";
import { Button } from "@mui/material";
import "./fuel-gauge-animation.js";

const Repo = () => {
  const location = useLocation();
  const { option } = location.state || {};
  //console.log("option", option);
  const [activeStep, setActiveStep] = useState(1);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [formData, setFormData] = useState({
    keyImage: null,
    gasLevel: "",
    carImages: {
      frontLeft: null,
      frontRight: null,
      backLeft: null,
      backRight: null,
    },
    additionalNotes: "",
  });

  // Handle image upload for key image
  const handleKeyImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        keyImage: file,
      });
    }
  };

  // Handle image upload for car images
  const handleCarImageChange = (e, position) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        carImages: {
          ...formData.carImages,
          [position]: file,
        },
      });
    }
  };

  useEffect(() => {
    // Initialize the fuel gauge animation when the component mounts
    if (window.initializeFuelGauge) {
      window.initializeFuelGauge();
    }
  }, []);

  // Handle gas level input
  const handleGasLevelChange = (e) => {
    const newValue = e.target.value;
    setFormData({
      ...formData,
      gasLevel: newValue,
    });

    // Update the custom fuel gauge animation
    if (window.updateFuelGauge) {
      window.updateFuelGauge(newValue);
    }
  };

  // Handle notes change
  const handleNotesChange = (e) => {
    setFormData({
      ...formData,
      additionalNotes: e.target.value,
    });
  };

  // Remove image
  // Handle removing an image
  const handleRemoveImage = (type, position = null) => {
    if (type === "key") {
      setFormData({
        ...formData,
        keyImage: null,
      });
      // Safely reset the file input
      const fileInput = document.getElementById("keyImageInput");
      if (fileInput) fileInput.value = "";
    } else if (type === "car") {
      setFormData({
        ...formData,
        carImages: {
          ...formData.carImages,
          [position]: null,
        },
      });
      // Safely reset the file input
      const fileInput = document.getElementById(`${position}ImageInput`);
      if (fileInput) fileInput.value = "";
    }
  };

  // Handle next step
  const handleNext = () => {
    setActiveStep(2);
  };

  // Handle previous step
  const handleBack = () => {
    setActiveStep(1);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setshowLoaderAdmin(true);
    // Form is valid, proceed with submission
    //console.log("Form data:", formData);
    let fd_from = new FormData();
    fd_from.append("booking_id", option.primary_id);
    fd_from.append("user_id", option.user_id);
    fd_from.append("car_id", option.car_id);
    fd_from.append("Key_image", formData.keyImage);
    fd_from.append("gas_level", formData.gasLevel);
    fd_from.append("front_left_car_images", formData.carImages.frontLeft);
    fd_from.append("front_right_car_images", formData.carImages.frontRight);
    fd_from.append("back_left_car_images", formData.carImages.backLeft);
    fd_from.append("back_right_car_images", formData.carImages.backRight);
    fd_from.append("notes", formData.additionalNotes);

    await server_post_data(car_repo_api, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccessSession(Response.data.message, "/Bookings");
        }
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
    // Here you would typically send the data to your backend

    // Reset form after submission
    setFormData({
      keyImage: null,
      gasLevel: "",
      carImages: {
        frontLeft: null,
        frontRight: null,
        backLeft: null,
        backRight: null,
      },
      additionalNotes: "",
    });

    // Reset to first step
    setActiveStep(1);

    // Reset file inputs
    document.getElementById("keyImageInput").value = "";
    document.getElementById("frontLeftImageInput").value = "";
    document.getElementById("frontRightImageInput").value = "";
    document.getElementById("backLeftImageInput").value = "";
    document.getElementById("backRightImageInput").value = "";
  };

  return (
    <>
      {showLoaderAdmin && <Loader />}
      <Header />
      <div className="pageCntn_head">
        <div className="pageNameDiv">
          <p>Vehicle Repossession Form</p>

          <img src={GreyArrow} alt="Rapid Car Leasing" />
        </div>
        <Button
          onClick={goBack}
          startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
          className="Back_bttn_page"
        >
          Back
        </Button>
      </div>
      <div className="mt-0 repo-container">
        <div className="repo-header">
          {/* <h2>Vehicle Repossession Form</h2> */}
          <div className="repo-step-indicator">
            {activeStep === 1
              ? "Vehicle Documentation"
              : "Additional Information"}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="repo-form">
          {/* Step 1: Key Image, Gas Level and Car Images */}
          {activeStep === 1 && (
            <div className="repo-form-step-content">
              {/* Key Image and Gas Level Row */}
              <div className="repo-section row ">
                {/* Key Image Section */}
                <div className="col-md-6">
                  <div className="mt-2" style={{ padding: "10px" }}>
                    <div className="repo-section-header">
                      <Key className="repo-form-icon" />
                      <h4>Key Image</h4>
                    </div>
                    <div className="repo-form-image-upload">
                      {!formData.keyImage ? (
                        <input
                          id="keyImageInput"
                          type="file"
                          accept="image/*"
                          onChange={handleKeyImageChange}
                          className="form-control file-input"
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={
                              URL.createObjectURL(formData.keyImage) ||
                              "/placeholder.svg"
                            }
                            alt="Key"
                            style={{ height: "100px", width: "100px" }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() => handleRemoveImage("key")}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Gas Level Section */}
                <div className="col-md-6">
                  <div className="mt-2" style={{ padding: "10px" }}>
                    <div className="repo-section-header">
                      <Fuel size={20} className="repo-icon" />
                      <h4>Gas Level</h4>
                    </div>
                    <div className="repo-gas-level">
                      <div className="repo-gas-gauge">
                        <div className="repo-gas-indicator">
                          <div className="repo-gas-level-marks mt-2">
                            {[...Array(11)].map((_, i) => (
                              <div
                                key={i}
                                className={`repo-gas-mark ${
                                  Number(formData.gasLevel) >= i ? "active" : ""
                                }`}
                              >
                                {i % 2 === 0 && (
                                  <span className="repo-gas-mark-label">
                                    {i}
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                          <input
                            type="range"
                            min="0"
                            max="10"
                            step="1"
                            value={formData.gasLevel || 0}
                            onChange={handleGasLevelChange}
                            className="repo-range-input"
                          />
                        </div>
                        <div className="repo-gas-input-group">
                          <span className="repo-gas-label">Fuel Level:</span>
                          <div className="repo-gas-input">
                            <input
                              type="number"
                              value={formData.gasLevel}
                              onChange={handleGasLevelChange}
                              min="0"
                              max="10"
                              className="repo-number-input"
                            />
                            <span className="repo-gas-max">/10</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Car Images Section */}
              <div className="repo-section row">
                <div className="repo-section-header">
                  <Camera className="repo-form-icon" />
                  <h4>Car Images (4 Corners)</h4>
                </div>
                <div className="repo-form-car-images">
                  <div className="row">
                    {/* Front Left */}
                    <div className="col-md-6 col-lg-3 mb-3">
                      <label
                        htmlFor="frontLeftImageInput"
                        className="form-label"
                      >
                        Driver Left
                      </label>
                      {!formData.carImages.frontLeft ? (
                        <input
                          id="frontLeftImageInput"
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleCarImageChange(e, "frontLeft")}
                          className="form-control file-input"
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={
                              URL.createObjectURL(
                                formData.carImages.frontLeft
                              ) || "/placeholder.svg"
                            }
                            alt="Front Left"
                            style={{
                              height: "100px",
                              width: "100px",
                              borderRadius: "6px",
                            }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImage("car", "frontLeft")
                            }
                          />
                        </div>
                      )}
                    </div>

                    {/* Front Right */}
                    <div className="col-md-6 col-lg-3 mb-3">
                      <label
                        htmlFor="frontRightImageInput"
                        className="form-label"
                      >
                        Driver Right
                      </label>
                      {!formData.carImages.frontRight ? (
                        <input
                          id="frontRightImageInput"
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            handleCarImageChange(e, "frontRight")
                          }
                          className="form-control file-input"
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={
                              URL.createObjectURL(
                                formData.carImages.frontRight
                              ) || "/placeholder.svg"
                            }
                            alt="Front Right"
                            style={{
                              height: "100px",
                              width: "100px",
                              borderRadius: "6px",
                            }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImage("car", "frontRight")
                            }
                          />
                        </div>
                      )}
                    </div>

                    {/* Back Left */}
                    <div className="col-md-6 col-lg-3 mb-3">
                      <label
                        htmlFor="backLeftImageInput"
                        className="form-label"
                      >
                        Passanger Left
                      </label>
                      {!formData.carImages.backLeft ? (
                        <input
                          id="backLeftImageInput"
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleCarImageChange(e, "backLeft")}
                          className="form-control file-input"
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={
                              URL.createObjectURL(
                                formData.carImages.backLeft
                              ) || "/placeholder.svg"
                            }
                            alt="Back Left"
                            style={{
                              height: "100px",
                              width: "100px",
                              borderRadius: "6px",
                            }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() => handleRemoveImage("car", "backLeft")}
                          />
                        </div>
                      )}
                    </div>

                    {/* Back Right */}
                    <div className="col-md-6 col-lg-3 mb-3">
                      <label
                        htmlFor="backRightImageInput"
                        className="form-label"
                      >
                        Passanger Right
                      </label>
                      {!formData.carImages.backRight ? (
                        <input
                          id="backRightImageInput"
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleCarImageChange(e, "backRight")}
                          className="form-control file-input"
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={
                              URL.createObjectURL(
                                formData.carImages.backRight
                              ) || "/placeholder.svg"
                            }
                            alt="Back Right"
                            style={{
                              height: "100px",
                              width: "100px",
                              borderRadius: "6px",
                            }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImage("car", "backRight")
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="repo-form-navigation">
                <button
                  type="button"
                  className="repo-form-next-btn"
                  onClick={handleNext}
                >
                  Next <ArrowRight size={16} />
                </button>
              </div>
            </div>
          )}

          {/* Step 2: Additional Notes */}
          {activeStep === 2 && (
            <div className="repo-form-step-content">
              {/* Additional Notes Section */}
              <div className="repo-section">
                <div className="repo-section-header">
                  <FileText className="repo-form-icon" />
                  <h4>Additional Notes</h4>
                </div>
                <div className="repo-form-notes">
                  <textarea
                    value={formData.additionalNotes}
                    onChange={handleNotesChange}
                    className="form-control noteSection"
                    placeholder="Enter any additional information about the vehicle..."
                    rows={4}
                  ></textarea>
                </div>
              </div>

              <div className="repo-form-navigation">
                <button
                  type="button"
                  className="repo-form-back-btn"
                  onClick={handleBack}
                >
                  <ArrowLeft size={16} /> Back
                </button>
                <button type="submit" className="repo-form-submit-btn">
                  Submit
                </button>
              </div>
            </div>
          )}
        </form>
      </div>
    </>
  );
};

export default Repo;
